import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Form, Button, Modal } from 'react-bootstrap';
import arrowright from '../../../../assets/img/icons/rightarrow.svg'
import Religion from '../../../commoncomponents/religion';
import Language from '../../../commoncomponents/language';
import close from '../../../../assets/img/icons/close.svg'
import male from '../../../../assets/img/interest/male.svg';
import female from '../../../../assets/img/interest/female.svg';
import other from '../../../../assets/img/interest/other.svg';
import maleactive from '../../../../assets/img/interest/maleactive.svg';
import femaleactive from '../../../../assets/img/interest/femaleactive.svg';
import otheractive from '../../../../assets/img/interest/otheractive.svg';
import ls from "local-storage";
import axios from 'axios';
import { Trans } from "react-i18next";   
import "../../../../config/i18n";
import { withTranslation } from "react-i18next";

class ProfileInfo extends Component {
    constructor(props) {
        super(props);
        this.onChangejob = this.onChangejob.bind(this);
        this.onChangecompany = this.onChangecompany.bind(this);
        this.onChangeschool = this.onChangeschool.bind(this);
        this.onChangeBio = this.onChangeBio.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            selectedDate: null,
            religionmodalmodal: false,
            langaugemodal: false,
            selectedOptions: {
                male: false,
                female: false,
                others: false
            },
            phone: '',
            langKey: ls.get('LangValue'),
            api_url: localStorage.getItem('api_url'),
            religion_items:[],
            language_items:[],
            religions_data: [],
            languages_data: [],
            job: '',
            company: '',
            school: '',
            bio: '',
            name: '',
        };
    }

    toggleOption = (option, row) => {
        if (row === 'gender') {
            this.setState({
                selectedOptions: option
            });
        } else {
            console.log('gender is not defined')
        }
    };

    componentDidMount() {
        let data = new FormData(); 
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
        data.append('language', this.state.langKey);

        axios({
            method: 'post',
            url: this.state.api_url+'webprofile',
            data: data, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => { 
            if(res.data.status !== false) {
                const user_details = res.data.result;
                console.log("DETAILS: ", user_details); 
                this.setState({
                    user_details: user_details,
                    name: user_details.user_name,
                    selectedOptions: user_details.gender,
                    bio: user_details.bio,
                    job: user_details.job,
                    company: user_details.company,
                    school: user_details.school,
                    phone: user_details.phone,
                    relogion: user_details.relogion1,
                    language: user_details.language1,
                    age: user_details.age,
                    email: user_details.email,
                });
                this.setState({ religion_items: user_details.relogion });  
                this.setState({ language_items: user_details.language });
            } else { 
                this.props.history.push("/"); 
            }  
        }).catch(error => {
            this.props.history.push("/");
        });
    }

    handleReligionOpenModal = () => {
        this.setState({ religionmodal: true });
    }

    handleReligionCloseModal = () => {
        this.setState({ religionmodal: false });
    }

    handleLanguageOpenModal = () => {
        this.setState({ langaugemodal: true });
    }

    handleLanguageCloseModal = () => {
        this.setState({ langaugemodal: false });
    }

    onChangejob(e){
        this.setState({
            job:e.target.value,
        });
    }

    onChangecompany(e){
        this.setState({
            company:e.target.value,
        });
    }

    onChangeschool(e){
        this.setState({
            school:e.target.value, 
        });
    }

    onChangeBio(e) {
        this.setState({
            bio: e.target.value,
        });
    }

    onChangeName(e) {
        this.setState({
            name: e.target.value,
        });
    }

    onSubmit(e){
        e.preventDefault();
        var editprofile = new FormData();
        editprofile.set('user_name', this.state.name);
        editprofile.set('phone', this.state.phone);
        editprofile.set('gender', this.state.selectedOptions);
        editprofile.set('bio', this.state.bio);
        editprofile.set('job', this.state.job);
        editprofile.set('company', this.state.company);
        editprofile.set('school', this.state.school);
        editprofile.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        editprofile.set('language', this.state.langKey);
        editprofile.set('relogion', localStorage.getItem('seleted_religion'));
        editprofile.set('user_languages', localStorage.getItem('selected_language'));
        axios({
            method: 'post',
            url: this.state.api_url+'websetprofile',
            data: editprofile,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status !== false) {
                this.setState({ noeditprofile: res.data.message });
                setTimeout(() => {
                    this.setState({
                        noeditprofile: ''
                    });
                    window.location.reload();
                }, 2000);
            }
        });
    }

    render() {
        const maxLength = 150;
        const { t } = this.props;
        return (
            <>
                <div className="">
                    <Modal className="modal_div profileinfo_modal" show={this.props.showModal} onHide={this.props.handleClose} centered>
                        <Modal.Header>
                            <Modal.Title><Trans i18nKey="Edit Profile">Edit Profile</Trans></Modal.Title>
                            <Button className="close" onClick={this.props.handleClose}>
                                <img src={close} alt="img" />
                            </Button>
                        </Modal.Header>
                        <Modal.Body className="profilemodal_body">
                            <Form className="profile_Welcome welcome_form" onSubmit={this.onSubmit}>
                                <div className='profileform_height'>
                                    {/* Phone */}
                                    <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                                        <Form.Label><Trans i18nKey="Phone Number">Phone Number</Trans></Form.Label>
                                        <NavLink to="/Editphonefirebase">
                                            <div className='phone_no_div'>
                                                <div>
                                                    <div>
                                                        <Form.Control style={{ cursor: 'pointer', color: '#7E838D' }} value={this.state.phone} placeholder="" required/>
                                                    </div>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </Form.Group>

                                    {/* Username */}
                                    <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                                        <Form.Label><Trans i18nKey="User Name">User Name</Trans></Form.Label>
                                        <div >
                                            <Form.Control style={{color: '#7E838D'}} value={this.state.name} onChange={this.onChangeName} placeholder={t("Enter user name")} required/>
                                        </div>
                                    </Form.Group>

                                    {/* Email */}
                                    <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                                        <Form.Label><Trans i18nKey="E-mail">E-mail</Trans></Form.Label>
                                        <div >
                                            <Form.Control style={{color: '#7E838D'}} value={this.state.email} placeholder={t("Enter your email")} readOnly required/>
                                        </div>
                                    </Form.Group>

                                    {/* Age */}
                                    <Form.Group controlId="formPlaintextPassword" className="welcome_form_div">
                                        <Form.Label><Trans i18nKey="Age">Age</Trans></Form.Label>
                                        <div>
                                            <Form.Control style={{color: '#7E838D'}} value={this.state.age} placeholder={t("Enter your Age")} readOnly required/>
                                        </div>
                                    </Form.Group>

                                    {/* Gender */}
                                    <Form.Group controlId="formPlaintextPassword" className="welcome_form_div">
                                        <Form.Label><Trans i18nKey="Gender">Gender</Trans></Form.Label>
                                        <div className='profile_seeking'>
                                            <div className={`profile_seeking_div ${this.state.selectedOptions === "male" ? 'profileseekingselect' : ''}`} onClick={() => this.toggleOption('male', 'gender')}>
                                                <div className='profile_seeking_subdiv'>
                                                    <img src={male} alt="img" />
                                                    <img src={maleactive} alt="img" />
                                                </div>
                                            </div>
                                            <div className={`profile_seeking_div ${this.state.selectedOptions === "female" ? 'profileseekingselect' : ''}`} onClick={() => this.toggleOption('female', 'gender')}>
                                                <div className='profile_seeking_subdiv'>
                                                    <img src={female} alt="img" />
                                                    <img src={femaleactive} alt="img" />
                                                </div>
                                            </div>
                                            <div className={`profile_seeking_div ${this.state.selectedOptions === "others" ? 'profileseekingselect' : ''}`} onClick={() => this.toggleOption('others', 'gender')}>
                                                <div className='profile_seeking_subdiv'>
                                                    <img src={other} alt="img" />
                                                    <img src={otheractive} alt="img" />
                                                </div>
                                            </div>
                                        </div>
                                    </Form.Group>

                                    {/* Bio */}
                                    <Form.Group className="welcome_form_div" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label><Trans i18nKey="Biography">Biography</Trans></Form.Label>
                                        <div className='textarea_position'>
                                            <Form.Control
                                                as="textarea"
                                                rows={1}
                                                name="biography"
                                                value={this.state.bio}
                                                maxLength={maxLength}
                                                onChange={this.onChangeBio}
                                                required
                                            />
                                            <span className='no_txt'>{this.state.bio.length}/{maxLength}</span>
                                        </div>
                                    </Form.Group>

                                    {/* Religion */}
                                    <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                                        <Form.Label><Trans i18nKey="Religion">Religion</Trans></Form.Label>
                                        <div className='signup_select'>
                                            <div onClick={this.handleReligionOpenModal}>
                                                {localStorage.getItem('seleted_religion')}
                                            </div>
                                        </div>
                                    </Form.Group>

                                    {/* Language */}
                                    <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                                        <Form.Label><Trans i18nKey="Language">Language</Trans></Form.Label>
                                        <Form.Control style={{color: '#7E838D'}} value={localStorage.getItem('selected_language')} onClick={this.handleLanguageOpenModal} placeholder={t("Select the Language")}/>
                                    </Form.Group>

                                    {/* Job */}
                                    <Form.Group controlId="formPlaintextPassword" className="welcome_form_div">
                                        <Form.Label><Trans i18nKey="Job Title">Job Title</Trans></Form.Label>
                                        <div>
                                            <Form.Control style={{color: '#7E838D'}} value={this.state.job} onChange={this.onChangejob} maxLength={60} placeholder={t("Enter your Job Name")} required />
                                        </div>
                                    </Form.Group>

                                    {/* Company */}
                                    <Form.Group controlId="formPlaintextPassword" className="welcome_form_div">
                                        <Form.Label><Trans i18nKey="Company Name">Company Name</Trans></Form.Label>
                                        <div>
                                            <Form.Control style={{color: '#7E838D'}} value={this.state.company} onChange={this.onChangecompany} maxLength={60} placeholder={t("Enter your Company")} required />
                                        </div>
                                    </Form.Group>

                                    {/* School */}
                                    <Form.Group controlId="formPlaintextPassword" className="welcome_form_div">
                                        <Form.Label><Trans i18nKey="School Name">School Name</Trans></Form.Label>
                                        <div>
                                            <Form.Control style={{color: '#7E838D'}} value={this.state.school} onChange={this.onChangeschool} maxLength={60} placeholder={t("Enter your School name")} required />
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className='required_div'>
                                    <p><span>*</span><Trans i18nKey="Fill the religion , language and biography fields">Fill the religion , language and biography fields</Trans></p>
                                </div>
                                <div className="errorMsg" style={{ paddingLeft: "25px" }}>{this.state.noeditprofile}</div>
                                <Button type="submit" className="button_primary"><Trans i18nKey="Save">Save</Trans></Button>
                            </Form>
                        </Modal.Body>
                    </Modal>
                </div>
                <Religion
                    showModal={this.state.religionmodal}
                    handleClose={this.handleReligionCloseModal}
                />

                <Language
                    showModal={this.state.langaugemodal}
                    handleClose={this.handleLanguageCloseModal}
                />
            </>
        );
    }
}

export default withTranslation("translations")(ProfileInfo);
